import { render, staticRenderFns } from "./InnButton.vue?vue&type=template&id=1a78915e"
import script from "./InnButton.vue?vue&type=script&lang=js"
export * from "./InnButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports